import { useEffect } from 'react'

/**
 * Add keydown event listener for document
 *
 * @param callback - function that calls when the specified key pressed
 * @param key - key KeyboardEvent property
 * @param dependencies - array of dependencies (optional)
 */
export const useKeyDown = (callback: Function, key: string, isAlt?: boolean) => {
  useEffect(() => {
    const keydownHandler = (e: KeyboardEvent) => {
      if (e.key !== key) return
      if (isAlt) {
        if (!e.altKey) return
      }

      callback()
    }

    document.addEventListener('keydown', keydownHandler)

    return () => {
      document.removeEventListener('keydown', keydownHandler)
    }
  })
}
